/**
 * The O Collection — split-flap ("destination board") nav effect.
 * Wraps [data-flap-board] text into individual dark flap tiles (see
 * reference: airport/cruise departure board). Tiles click through a
 * short run of plausible characters — deliberately, not a fast glitch —
 * before landing, staggered left to right so a row visibly "loads in."
 * Only runs when the nav overlay opens or a row expands, never on hover.
 */
(function () {
  "use strict";

  var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var TICK_MS = 110;
  var TICKS_MIN = 6;
  var TICKS_MAX = 10;
  var CHAR_STAGGER_MS = 55;
  var ROW_STAGGER_MS = 90;

  var prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  function buildTiles(el) {
    if (el.dataset.flapBuilt) return;
    var text = el.textContent;
    el.textContent = "";
    text.split("").forEach(function (ch) {
      if (ch === " ") {
        var spacer = document.createElement("span");
        spacer.className = "flap-space";
        el.appendChild(spacer);
        return;
      }
      var tile = document.createElement("span");
      tile.className = "flap-tile";
      var face = document.createElement("span");
      face.className = "flap-tile__face";
      face.textContent = ch;
      tile.appendChild(face);
      tile.dataset.final = ch;
      el.appendChild(tile);
    });
    el.dataset.flapBuilt = "true";
  }

  function flapOneTile(tile, delay) {
    var final = tile.dataset.final;
    var face = tile.querySelector(".flap-tile__face");

    if (prefersReducedMotion) {
      face.textContent = final;
      return;
    }

    var ticks = TICKS_MIN + Math.floor(Math.random() * (TICKS_MAX - TICKS_MIN));
    setTimeout(function () {
      tile.classList.add("is-flapping");
      var count = 0;
      var id = setInterval(function () {
        count++;
        if (count >= ticks) {
          clearInterval(id);
          face.textContent = final;
          tile.classList.remove("is-flapping");
          tile.classList.add("is-settled");
          return;
        }
        face.textContent = CHARSET[Math.floor(Math.random() * CHARSET.length)];
      }, TICK_MS);
    }, delay);
  }

  function flapBoard(el, rowDelay) {
    buildTiles(el);
    var tiles = el.querySelectorAll(".flap-tile");
    for (var i = 0; i < tiles.length; i++) {
      tiles[i].classList.remove("is-settled");
      flapOneTile(tiles[i], (rowDelay || 0) + i * CHAR_STAGGER_MS);
    }
  }

  function flapBoardGroup(elements) {
    for (var i = 0; i < elements.length; i++) {
      flapBoard(elements[i], i * ROW_STAGGER_MS);
    }
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  /**
   * Boards marked [data-flap-scroll] flap into place the first time they
   * scroll into view (e.g. the flagship "BODRUM / EDITION" plate). Tiles are
   * pre-built and blanked so the answer isn't spoiled before the flap runs.
   */
  function initScrollBoards() {
    var groups = toArray(document.querySelectorAll("[data-flap-scroll]"));
    if (!groups.length) return;

    groups.forEach(function (group) {
      toArray(group.querySelectorAll(".flap-board")).forEach(function (board) {
        buildTiles(board);
        toArray(board.querySelectorAll(".flap-tile__face")).forEach(function (face) {
          face.textContent = "";
        });
      });
    });

    function settle(group) {
      toArray(group.querySelectorAll(".flap-tile")).forEach(function (tile) {
        tile.querySelector(".flap-tile__face").textContent = tile.dataset.final;
      });
    }

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      groups.forEach(settle);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          flapBoardGroup(toArray(entry.target.querySelectorAll(".flap-board")));
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );
    groups.forEach(function (group) { observer.observe(group); });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initScrollBoards();

    // --- Header search overlay (self-contained; independent of the nav board) ---
    (function () {
      var sToggle = document.querySelector("[data-search-toggle]");
      var sOverlay = document.querySelector("[data-search-overlay]");
      if (!sToggle || !sOverlay) return;
      var sClose = sOverlay.querySelector("[data-search-close]");
      var sInput = sOverlay.querySelector("[data-search-input]");

      function openSearch() {
        sOverlay.classList.add("is-open");
        sToggle.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";
        if (sInput) setTimeout(function () { sInput.focus(); }, 60);
      }
      function closeSearch() {
        sOverlay.classList.remove("is-open");
        sToggle.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
      }

      sToggle.addEventListener("click", function () {
        if (sOverlay.classList.contains("is-open")) closeSearch(); else openSearch();
      });
      if (sClose) sClose.addEventListener("click", closeSearch);
      sOverlay.addEventListener("click", function (e) {
        if (e.target === sOverlay) closeSearch();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && sOverlay.classList.contains("is-open")) closeSearch();
      });
    })();

    var toggle = document.querySelector("[data-nav-toggle]");
    var overlay = document.querySelector("[data-nav-overlay]");
    var closeBtn = document.querySelector("[data-nav-close]");
    if (!toggle || !overlay) return;

    function openNav() {
      overlay.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      var targets = overlay.querySelectorAll(".nav-board__row > .nav-board__link [data-flap-board]");
      flapBoardGroup(toArray(targets));
    }

    function closeNav() {
      overlay.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }

    toggle.addEventListener("click", function () {
      if (overlay.classList.contains("is-open")) {
        closeNav();
      } else {
        openNav();
      }
    });

    if (closeBtn) closeBtn.addEventListener("click", closeNav);

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeNav();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && overlay.classList.contains("is-open")) closeNav();
    });

    // Sub-menu rows: flap the sub-items in the moment a row expands.
    var subToggles = overlay.querySelectorAll("[data-row-toggle]");
    for (var s = 0; s < subToggles.length; s++) {
      subToggles[s].addEventListener("click", function (e) {
        e.preventDefault();
        var row = this.closest(".nav-board__row");
        var isOpen = row.classList.toggle("is-expanded");
        if (isOpen) {
          var subTargets = row.querySelectorAll(".nav-board__sublist [data-flap-board]");
          flapBoardGroup(toArray(subTargets));
        }
      });
    }
  });
})();
